import i18next from "i18next";
import instance from "../../config/axios";

export async function submitData(id: number | undefined, data: any) {
    const jsonData: any = {};
    
    for (const key in data) {
        if (data[key] !== undefined && data[key] !== null) {
            if (key === "status") {
                jsonData['status'] = data.status ? 1 : 0;
            } else if (key === "name" || key === "description") {
                jsonData[`${key}`] = data[key];
            } else {
                jsonData[key] = data[key];
            }
        }
    }

    const url = id ? `/online_application_users/${id}` : `/online_application_users`;
    const response = await instance({
        url,
        method: id ? "PUT" : "POST",
        headers: {
            'Content-Type': 'application/json',
        },
        data: JSON.stringify(jsonData),
    });

    return response.data;
}

  